export const WINDOW_IDS = {
  COBERTURAS_HOJA_QX: "coberturas-hoja-qx",
  ANEXOS: "anexos",
};

export const WINDOW_TITLES = {
  COBERTURAS_HOJA_QX: "Coberturas Hoja QX",
  ANEXOS: "Anexos",
};

export const DataFormatters = {
  formatDate: (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch (error) {
      return "N/A";
    }
  },
};

export const MENSAJE_EXITO_ENVIO = {
  tipo: "success",
  titulo: "Hoja quirúrgica agregada",
  mensaje:
    "Se ha agregado de forma satisfactoria la hoja quirúrgica. Nuestro equipo estará revisando la solicitud y actualizando el estatus de las coberturas reclamadas. Te estaremos informando del progreso de esta solicitud vía correo electrónico. Para conocer el estatus de cada cobertura, puedes consultarlo utilizando el mismo número de solicitud de autorización.",
};

